import 'echarts/build/echarts-all.js';
import {
  Measure
} from '../../common/measure';
// import {
//   hoursToTime,
//   ticksFormat,
//   ticksToHours
// } from '../../common/datetime';

// import echarts from 'echarts/lib/echarts'
// import 'echarts/lib/chart/bar';
// import 'echarts/lib/chart/line';

/*@ngInject*/
class RadarController {
  constructor($scope,
    $element,
    $timeout,
    RouterService,
    LayoutService,
    rx
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.router = RouterService;
    this.LayoutService = LayoutService;
    this.LayoutService.drilldownMax = 2;
    this.getMeasure = Measure.getMeasure;
    this.container = null;
    this.chart = null;
    this.chartAreaIsStacked = true;
    this.minHeight = 1;
    this.minWidth = 1;
    this.renderDebounce = 100;
    this.drill1Limit = 20;
    this.drill2Limit = 30;
    this.aggregate = null;
    this.filter = null;

    const subscriptions = [
      rx.Observable.merge(
        $scope.$eventToObservable('resizeBeforePrint'),
        rx.Observable.merge(
          $scope.$eventToObservable('afterPrint'),
          $scope.$eventToObservable('dashboardResize'),
          $scope.$eventToObservable('resize'),
          $scope.$eventToObservable('splitter1Changed'),
        ).debounce(this.renderDebounce))
      .subscribe(() => this.resize()),
      rx.Observable.merge(
        // $scope.$eventToObservable('beforePrint'),
        rx.Observable.merge(
          $scope.$toObservable('$ctrl.filter.orders'),
          $scope.$toObservable('$ctrl.filter.orderDirs'),
          $scope.$toObservable('$ctrl.aggregate'),
        ).debounce(this.renderDebounce),
      )
      .subscribe((e) => this.render(e)),
    ];

    $scope.$on('$destroy', () => {
      subscriptions.forEach((subscription) => {
        subscription.dispose();
      });
      this.LayoutService.drilldownMax = 0;
    });
  }

  get isPrint() {
    return this.router.pdf || this.LayoutService.isPrint;
  }

  resize() {
    if (this.chart && this.$element.height() > this.minHeight &&
      this.$element.width() > this.minWidth) {
      this.chart.resize();
    }
  }

  getSortPredicate(sortName, data) {
    const sortPredicates = {
      drill1_asc: (a, b) => a < b ? 1 : -1,
      drill1_desc: (a, b) => a > b ? 1 : -1,
      drill1_measure_asc: (a, b) => data.drill1[a] - data.drill1[b],
      drill1_measure_desc: (a, b) => data.drill1[b] - data.drill1[a],
      drill2_asc: (a, b) => a > b ? 1 : -1,
      drill2_desc: (a, b) => a < b ? 1 : -1,
      drill2_measure_asc: (a, b) => data.drill2[a].summ - data.drill2[b].summ,
      drill2_measure_desc: (a, b) => data.drill2[b].summ - data.drill2[a].summ,
    };
    return sortPredicates[sortName];
  }

  getDrillSortKey(prefix, drill) {
    const index = this.filter.orders.indexOf(this.model.getDrillAttr(drill));
    const indexMeasure = this.filter.orders.indexOf('measure');
    if (index !== -1 && (indexMeasure === -1 || index < indexMeasure)) {
      if (this.filter.orderDirs && this.filter.orderDirs[index])
        return `${prefix}_${this.filter.orderDirs[index]}`;
      return `${prefix}_asc`;
    }
    if (indexMeasure !== -1 && (index === -1 || index > indexMeasure)) {
      if (this.filter.orderDirs && this.filter.orderDirs[indexMeasure])
        return `${prefix}_measure_${this.filter.orderDirs[indexMeasure]}`;
    }
    return `${prefix}_measure_desc`;
  }

  limitTo40(s) {
    return s.length > 40 ? s.substring(0, 40) + '...' : s;
  }

  updateOptions(options) {
    const getValue = cell => {
      if (this.filterData.filter.measure === 'activity_time_sum' ||
        this.filterData.filter.measure === 'call_duration_sum') return cell[this.filterData.filter.measure];
      return cell.record_count;
    };


    const drill1 = this.filterData.filter.drilldown[0];
    const drill2 = this.filterData.filter.drilldown[1] ? this.filterData.filter.drilldown[1] :
      this.filterData.filter.drilldown[0];
    if (drill2 === drill1) {
      options.title.text = this.model.getDrillLabel(drill2);
      options.title.subtext = '';
    } else {
      options.title.text = this.model.getDrillLabel(drill2) + ' -> ' +
        this.model.getDrillLabel(drill1);
      options.title.subtext = '';
    }

    // collecting data
    const data = this.filterData.filterData.cells.reduce((data, cell) => {
      const keyDrill1 = this.model.getCellLabel(drill1, cell);
      const keyDrill2 = this.limitTo40(this.model.getCellLabel(drill2, cell));
      const value = getValue(cell);
      if (drill2 !== drill1) {
        if (!(keyDrill2 in data.drill2)) data.drill2[keyDrill2] = {
          values: {},
          summ: 0
        };
        data.drill2[keyDrill2].values[keyDrill1] = value;
        data.drill2[keyDrill2].summ += value;
      }
      if (!(keyDrill1 in data.drill1)) data.drill1[keyDrill1] = value;
      if (data.drill1[keyDrill1] < value) data.drill1[keyDrill1] = value;
      return data;
    }, {
      maxValue: 0,
      drill2: {},
      drill1: {}
    });
    if (drill2 === drill1) {
      data.drill2 = {
        [options.title.text]: {
          values: angular.copy(data.drill1),
          summ: Object.keys(data.drill1).reduce((s, v) => s += data.drill1[v], 0),
        }
      };
    }

    // cat data up to top drill1Limit itims
    const keyOther = gettext('Другое');
    if (Object.keys(data.drill1).length > this.drill1Limit) {
      const drill1Arr = Object.keys(data.drill1);
      // drill1ArrCutted[this.dril2Limit] = keyOther;
      const drill1 = drill1Arr.sort((a, b) => data.drill1[b] - data.drill1[a])
        .slice(0, this.drill1Limit).concat(keyOther).reduce((dr1, keyDrill1) => {
          dr1[keyDrill1] = 0;
          return dr1;
        }, {});

      drill1Arr.map(keyDrill1 => {
        if (keyDrill1 in drill1) drill1[keyDrill1] = data.drill1[keyDrill1];
        else drill1[keyOther] += data.drill1[keyDrill1];
      });
      data.drill1 = drill1;
    }

    const drill1SortKey = this.getDrillSortKey('drill1', drill1);
    const sortDrill1Predicate = this.getSortPredicate(drill1SortKey, data);
    const drill1Arr = Object.keys(data.drill1).sort(sortDrill1Predicate);

    const drill2SortKey = this.getDrillSortKey('drill2', drill2);
    const sortDrill2Predicate = this.getSortPredicate(drill2SortKey, data);
    const drill2Arr = Object.keys(data.drill2).sort(sortDrill1Predicate);

    options.series[0].data = drill2Arr.sort(sortDrill2Predicate)
      .slice(0, this.drill2Limit).map(keyDrill2 => ({
        name: keyDrill2,
        value: drill1Arr.sort(sortDrill1Predicate).map(keyDrill1 => {
          let serVal = 0;
          if (keyDrill1 in data.drill2[keyDrill2].values) serVal = data.drill2[keyDrill2].values[keyDrill1];
          else if (keyDrill1 === keyOther) serVal = Object.keys(data.drill2[keyDrill2].values)
            .reduce((dr2Summ, keyDr2) =>
              dr2Summ += keyDr2 in data.drill1 ? 0 : data.drill2[keyDrill2].values[keyDr2], 0);
          if (data.maxValue < serVal) data.maxValue = serVal;
          return serVal ? serVal : '-';
        })
      }));

    options.polar[0] = {
      indicator: drill1Arr.sort(sortDrill1Predicate).map(keyDrill1 => ({
        text: keyDrill1,
        max: data.maxValue
      }))
    };
    options.series[0].name = options.title.text;

    options.legend.data = drill2Arr.sort(sortDrill2Predicate).slice(0, this.drill2Limit);
  }

  render(e) {
    if (!this.aggregate || !this.filter ||
      !this.filterData.filterData.cells.length) {
      return;
    }
    if (this.$element.height() <= this.minHeight ||
      this.$element.width() <= this.minWidth) {
      return;
    }

    this.container = this.$element[0];
    this.chart = echarts.init(this.container);
    const options = {
      animation: !this.isPrint,
      // animation: e.name !== 'beforePrint' && e.name !== 'resizeBeforePrint',
      title: {
        text: 'Компы',
        subtext: 'Сайт'
      },
      tooltip: {
        show: false,
        trigger: 'axis'
      },
      legend: {
        orient: 'vertical',
        x: 'right',
        y: 'bottom',
        data: ['Комп 1', 'Комп 2', 'Комп 3', ]
      },
      toolbox: {
        show: this.isPrint,
        feature: {
          mark: {
            show: false
          },
          dataView: {
            show: false,
          },
          restore: {
            show: true,
            title: gettext('Обновить'),
            lang: ['rus'],
          },
          saveAsImage: {
            show: true,
            title: gettext('Сохранить'),
            type: 'png',
            lang: [gettext('Сохранить'), '']
          }
        }
      },
      polar: [{
        indicator: []
      }],
      calculable: true,
      series: [{
        type: 'radar',
      }]
    };
    this.updateOptions(options);
    this.chart.setOption(options);
  }
}

export const RadarComponent = {
  template: require('./radar.component.html'),
  bindings: {
    model: '<',
    aggregate: '<',
    filter: '<',
    filterData: '<',
  },

  controller: RadarController,
};



// WEBPACK FOOTER //
// ./src/stat/radar/radar.component.js